import React, { useState, useEffect, useContext } from 'react'
import { Row, Col, Form, Modal, Radio, message, Space, Result } from 'antd';
// import StepperForm2 from '../components/admins/doctorAdmin/masterManagement/templateMaster/formNew/stepperFormNested';
import { FormContext } from '../components/admins/doctorAdmin/masterManagement/context-reducers/context-reducer';
// import GoogleTranslator from '../components/common/googleTranslator'
import DigitalForm from '../components/admins/doctorAdmin/masterManagement/templateMaster/formNew/digitalForm'
import axios from 'axios'
import { getDataFromDbForm, getSummaryFromData } from '../components/admins/doctorAdmin/masterManagement/templateMaster/functions';
import {
    BrowserRouter as Router,
    // Link,
    useLocation
} from "react-router-dom"
import {configVariables} from '../configs/configs';
import RedoStepperForm2 from '../components/admins/doctorAdmin/masterManagement/templateMaster/formNew/redoStepperFormNested';
import AxonichealthLogoBlackPng from "../assets/NewLogo.png";




let url = '';
if(window){
    url = window.location.href;
}

// let env = 'development';
// let environment = process.env.NODE_ENV ? process.env.NODE_ENV : env;

// if(url.indexOf('qa') != -1){
//     environment = 'testing'
// }

// if(url.indexOf('dev') != -1){
//     environment = 'development'
// }

// let apiEndpoint = 'https://cw5f8t8a3i.execute-api.ap-south-1.amazonaws.com/dev/api';

// if(environment == 'testing'){
//     apiEndpoint = 'https://o1xk7s8z3f.execute-api.ap-south-1.amazonaws.com/QA/api'
// }
// if(environment == 'production'){
//     apiEndpoint = 'https://j7oyaqlt83.execute-api.ap-south-1.amazonaws.com/prod/api'
// }


let apiEndpoint = configVariables.API_ENDPOINT;

const FormPreviewComp = (props) => {

    let answers = null;
    let initialValues = {}
    const FormContextComp = useContext(FormContext)

    const [form] = Form.useForm();

    let record = props.template;

    if (props.templateAns) {
        answers = props.templateAns;
        let arr = []
        record.attachedSections.map((item) => {
            let attachedQuestion = item.attachedQuestions;
            arr = arr.concat(attachedQuestion)
        })
        arr.map((item) => {
            let obj = answers.formData.find((a) => a.queUId == item.uId)
            if (obj) {
                let name = item.slugValue;
                initialValues[name] = {
                    answer: obj.ansText,
                    summary: obj.ansSummary
                }
            }
        })
    }

    const [summaryModal, setsummaryModal] = useState(false);
    const [loading, setloading] = useState(false);
    const [list, setlist] = useState([]);
    const [demoData, setdemoData] = useState(null)
    const [flag, setflag] = useState(false)
    const [formType, setformType] = useState('REGULAR');
    const [finalSummary, setfinalSummary] = useState(null);
    const [error, seterror] = useState(null);
    const [success, setsuccess] = useState(null);

    const formContainerStyle = {
        background: "linear-gradient(to bottom, #FCE0E0, #E0F3F2)",
        minHeight: '100vh',
        width: '100%',
        padding: '20px'
    };

    useEffect(() => {
        function delete_cookie(name) {
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          }
        
        delete_cookie('googtrans')
    }, []);
    
    
    useEffect(() => {
        if(demoData != null){
            document.title = demoData.title;
        }
    }, [demoData])


    
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    useEffect(() => {
        function delete_cookie(name) {
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          }
        
        delete_cookie('googtrans')
    }, []);
    
    let query = useQuery();
    // useEffect(() => {
    //     if (demoData && demoData != null) {
    //         createDatasource(demoData.rows)
    //     }

    //     let obj = localStorage.getItem('form');
    //     if (obj && obj != null) {
    //         obj = JSON.parse(obj)
    //     } else {
    //         obj = demoData
    //     }

    //     setdemoData(obj)
    //     createDatasource(obj.rows)
    // }, [])

    useEffect(() => {
        const fetchDataAsync = async () => {
     
            let ids = [];
            for (let entry of query.entries()) { 
                if(entry[0] && entry[0] == 'id'){
                    ids.push(entry[1])
                }
            }
            getFormByIdApiFunction(ids[0])
        }
        fetchDataAsync()
    }, [])



    const getFormByIdApiFunction=(id)=>{
        setloading(true)
        let getFormApi = `${apiEndpoint}/previewForm`;

        axios({
            method: 'post',
            url: getFormApi,
            headers: {
                'X-Api-Key': id,
                'Access-Control-Allow-Origin': '*'
            },
            })
          .then(function (response) {
        //   console.log((response.data))
              if(response.status == 203){
                setloading(false)
                seterror(response.data.message)
                return;
              }

            setloading(false)
            if(response.status == 200){
                let result = response.data ? response.data.result : null;
                if(result  && result != null){
                    let item = result;
                
                    if(item != null ){
                        let obj = getDataFromDbForm(item)
                        setdemoData(obj)
                        createDatasource(obj.rows)
                    } 
                }else{
                    seterror('Form not found')
                }
                setloading(false)
            }
          })
          .catch(function (error) {
              console.log(error)
              let errObj = JSON.parse(JSON.stringify(error))
            if(errObj && errObj.message && errObj.message.indexOf('403') != -1){
                seterror('Form not found')
            }else{
                seterror('There is some error')
            }
            setloading(false)

          });
    }


    const rerenderCustom = () => {
        setflag(!flag)
    }

    const createDatasource = (data) => {
        let ques = []
        data.forEach((item, i) => {
            item.columns.forEach((colItem) => {
                colItem.sections.forEach((secItem) => {
                    ques = ques.concat(secItem.questions)
                })
            })
        })
     
        setlist(ques)
    }

 

    const onFinish = (values) => {
        var htmlStr = '';
        var str = '';

        let obj = getSummaryFromData(list, values)

        htmlStr = obj.htmlStr;
        str = obj.str;

        setfinalSummary(htmlStr)
        setsummaryModal(true)

    }



    // const CallRenderForm = (item) => {
    //     return (
    //         <RenderForm
    //             // columns={columns}
    //             data={item.questions}
    //             pagination={false}
    //         />
    //     )
    // }


    if(error != null ){
        return(
            <div style={formContainerStyle}>
                <Result
                status="error"
                title={error.toUpperCase()}
                subTitle="Sorry for the inconvenience"
                />
            </div>
        )
    }

    return (
        <div style={formContainerStyle}>
            <Form
                onValuesChange={() => {
                    // rerenderCustom()
                }}
                initialValues={initialValues}
                form={form}
                onFinish={(values) => {
                    console.log(values)
                    setloading(true)
                    setTimeout(() => {
                        onFinish(values)
                        setloading(false)
                    }, 100);

                }}
                onFinishFailed={()=>{
                    message.warning('please fill up all the questions')
                }}
                onError={(err) => {
                    console.log(err)
                }}>

                {props.menu == undefined &&
                    <div style={{ width: '80%', margin: 'auto', marginTop: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Space>
                            <Radio.Group onChange={(e) => {
                                let val = e.target.value
                                setformType(val)
                                if (val == 'CHAT') {
                                    form.resetFields()
                                    setformType(val)
                                    // props.history.push('/submitForm2')
                                }
                            }} value={formType}>
                                <Radio value={'REGULAR'}>Digital</Radio>
                                {/* <Radio value={'DIGITAL'}>Digital</Radio>
                                    <Radio value={'CAROUSEL'}>Multi Step</Radio> */}
                                <Radio value={'CHAT'}>Chat</Radio>
                            </Radio.Group>
                        </Space>
                        <img style={{height:'50px'}} src={AxonichealthLogoBlackPng} alt="..." />
                    </div>
                }

                <Row>
                    <Col span={24} >
                        {formType == 'REGULAR' && demoData != null && 
                            <DigitalForm demoData={demoData} flag={flag} loading={loading} form={form} setflag={setflag} status={'EDIT'}/>
                        }

                        {formType == 'CHAT' &&
                            // <ChatLayout>
                            // {/* <StepperForm2 list={list} rerenderCustom={rerenderCustom} form={form} /> */}
                            <RedoStepperForm2 list={list} form={form}/>
                            // </ChatLayout>
                        }
                    </Col>
                </Row>



                {finalSummary != null &&
                    <Modal
                        width="80%"
                        visible={summaryModal}
                        onCancel={() => {
                            setsummaryModal(false)
                        }}
                        onOk={() => {
                            setsummaryModal(false)
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: finalSummary }}>

                        </div>

                    </Modal>
                }

            </Form>
        </div>
    )
}
export default FormPreviewComp;

